<template>
  <span class="icon iconfont icon-leixingrijishijianactiveno" />
</template>
